export const loadAncestors = (ancestors) => ({
  type: 'LOAD_ANCESTORS',
  ancestors,
})
